var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rewards-exclusive-pill-container"},[_c('img',{staticClass:"pepper-badge",attrs:{"src":_vm.pepperBadgeUrl}}),_c('div',{staticClass:"pill"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }